import React from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Nav,
  NavDropdown,
  Row,
} from "react-bootstrap";
import "./CourseFilters.css";
import ReactStars from "react-rating-stars-component";
import { IoMdArrowDropdown } from "react-icons/io";

export default function CourseFilters() {
  return (
    <div>
      <Container className="no-pad">
        <Row>
          <div>
            <Nav className="sup-btn">
              <NavDropdown title="Quick Filters" id="nav-dropdown">
                <NavDropdown.Item eventKey="4.1">Most Popular</NavDropdown.Item>
                <NavDropdown.Item eventKey="4.2">
                  Highest Rated{" "}
                </NavDropdown.Item>
                <NavDropdown.Item eventKey="4.3">Newest</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </div>
        </Row>
        <hr
          style={{
            height: 5,
          }}
        />
        <Row>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  Ratings
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form>
                    <Form.Group controlId="formBasicCheckbox" className="disp">
                      <Form.Check type="radio" label="4.5 & up" />{" "}
                      <div className="mask">
                        <ReactStars
                          count={5}
                          size={15}
                          activeColor="#eb8a2f"
                          value={4.5}
                          isHalf={true}
                          edit={false}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox" className="disp">
                      <Form.Check type="radio" label="4.0 & up" />{" "}
                      <div className="mask">
                        <ReactStars
                          count={5}
                          size={15}
                          activeColor="#eb8a2f"
                          value={4}
                          isHalf={true}
                          edit={false}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox" className="disp">
                      <Form.Check type="radio" label="3.5 & up" />{" "}
                      <div className="mask">
                        <ReactStars
                          count={5}
                          size={15}
                          activeColor="#eb8a2f"
                          value={3.5}
                          isHalf={true}
                          edit={false}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox" className="disp">
                      <Form.Check type="radio" label="3.0 & up" />{" "}
                      <div className="mask">
                        <ReactStars
                          count={5}
                          size={15}
                          activeColor="#eb8a2f"
                          value={3}
                          isHalf={true}
                          edit={false}
                        />
                      </div>
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Row>
        <Row>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  Video Duration
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="0 - 2 Hours Duration"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="3 - 6 Hours Duration"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="7 - 16 Hours Duration"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="17 + Hours Duration"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="17 + Hours Duration"
                        />{" "}
                      </Form.Group>
                    </div>
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Row>
        <Row>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  Topic
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Python (1,557)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Javascript (924)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Java (264)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Unity (766)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Web Development (675)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="PHP (648)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Wordpress (743)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="C# (356)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Android Development (545)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="iOS Development (586)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Machine Learning (156)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="React (253)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="CSS (1801)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="HTML (676)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Data Science (349)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="SWIFT (340)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Angular (302)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Node Js (298)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="SQL (291)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="C++ (285)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Programming Fundamentals (298)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Larvel (272)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="HTML5 (271)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="C (229)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="MySQL (227)" />{" "}
                      </Form.Group>
                    </div>
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Row>
        <Row>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  Sub Category
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Web Development (8,557)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Programming Languages (3,924)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Mobile Development (2,264)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Data Science (1,966)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Game Development (675)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Database Design (1,648)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Development Tools (743)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Software Engineer (1,256)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Software Testing (615)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="No-Code Development (306)"
                        />{" "}
                      </Form.Group>
                    </div>
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Row>
        <Row>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  Level
                  <span>
                    <IoMdArrowDropdown />
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="All Levels (10,000)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Begineer (9,735)" />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Intermediate (4,015)"
                        />{" "}
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group
                        controlId="formBasicCheckbox"
                        className="disp"
                      >
                        <Form.Check type="checkbox" label="Expert (498)" />{" "}
                      </Form.Group>
                    </div>
                  </Form>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Row>
      </Container>
    </div>
  );
}
